<div class="form-control input-display" [formlyAttributes]="field">{{ to['displayValue'] || model[keyAsString] }}</div>
